import React, {useCallback, useMemo, useState} from "react"
import {Box} from "@mui/material"
import SideBarLayout from "src/v2/layout/side-bar-layout"
import TabsWrappedLabel from "src/v2/components/tabs/tabs-component"
import CalculationsTab from "./components/calculations-tab"
import DailyReportTab from "./components/daily-report-tab"
import ReportDataTab from "./components/report-data-tab"
import WorkflowsTab from "./components/workflows-tab"

const ContingenciaPage = () => {
    const [selectedTab, setSelectedTab] = useState("workflows")
    const [loading, setLoading] = useState(false)
    const handleLoadingChange = useCallback((value) => setLoading(Boolean(value)), [])

    const tabs = useMemo(() => [
        {
            value: "workflows",
            label: "Workflows",
            content: <WorkflowsTab active onLoadingChange={handleLoadingChange}/>,
        },
        {
            value: "calculations",
            label: "Cálculos",
            content: <CalculationsTab active onLoadingChange={handleLoadingChange}/>,
        },
        {
            value: "report-data",
            label: "Relatório de dados",
            content: <ReportDataTab onLoadingChange={handleLoadingChange}/>,
        },
        {
            value: "daily-report",
            label: "Relatório noturno",
            content: <DailyReportTab active onLoadingChange={handleLoadingChange}/>,
        },
    ], [handleLoadingChange])

    return (
        <SideBarLayout
            title="Contingência"
            header
            loading={loading}
            headerImage="/background/eventos_headers.jpg"
            headerPosition="1% 42%"
            headerTitle="Contingência"
        >
            <Box sx={{mt: -2, pb: 4}}>
                <TabsWrappedLabel
                    tabs={tabs}
                    value={selectedTab}
                    onChange={(_event, value) => {
                        setLoading(false)
                        setSelectedTab(value)
                    }}
                />
            </Box>
        </SideBarLayout>
    )
}

export default ContingenciaPage
